import { useEffect, useState } from 'react'
import { useQueryParam, NumberParam } from 'use-query-params'

import { QUERY_PARAMS_KEY } from '@app/constants'
import { DEFAULT_PAGINATION } from '@app/constants/pagination'

import type { Pagination, PaginationHookReturn } from '@app/types/pagination'

export const usePaginationQuery = (): PaginationHookReturn => {
  const [currentPageQuery, setCurrentPageQuery] = useQueryParam(QUERY_PARAMS_KEY.currentPage, NumberParam)
  const [pageSizeQuery, setPageSizeQuery] = useQueryParam(QUERY_PARAMS_KEY.pageSize, NumberParam)

  const [pagination, setPagination] = useState<Pagination>({
    current: currentPageQuery ?? DEFAULT_PAGINATION.current,
    pageSize: pageSizeQuery ?? DEFAULT_PAGINATION.pageSize
  })

  const handlePaginationChange = (newPagination: Pagination): void => {
    const { current, pageSize } = newPagination

    if (current === DEFAULT_PAGINATION.current) {
      setCurrentPageQuery(null)
    } else if (current) {
      setCurrentPageQuery(current)
    }

    if (pageSize === DEFAULT_PAGINATION.pageSize) {
      setPageSizeQuery(null)
    } else if (pageSize) {
      setPageSizeQuery(pageSize)
    }
  }

  const handleCurrentPageReset = (): void => {
    setCurrentPageQuery(null)
  }

  useEffect(() => {
    const current = currentPageQuery ?? DEFAULT_PAGINATION.current

    setPagination(prevPagination => ({
      ...prevPagination,
      current
    }))
  }, [currentPageQuery])

  useEffect(() => {
    const pageSize = pageSizeQuery ?? DEFAULT_PAGINATION.pageSize

    setPagination(prevPagination => ({
      ...prevPagination,
      pageSize
    }))
  }, [pageSizeQuery])

  return {
    pagination,
    setPagination: handlePaginationChange,
    resetCurrentPage: handleCurrentPageReset
  }
}
